import OrganisationApi from '@packages/organisations/api';

import ProviderInvestor from '@/models/ProviderInvestor';

export class ProviderApi extends OrganisationApi {
    static resource = 'providers';

    get endpoints() {
        return {
            ...super.endpoints,
            getInvestorRelationships: this.getInvestorRelationships.bind(this)
        };
    }

    _filterProviderRelationshipResponseData(data) {
        if (!data) {
            return data;
        }

        const setId = item => ({
            id: `${item.investor?.id || item.investor_id || ProviderInvestor.default_investor_id}_${
                item.provider?.id || item.provider_id || ProviderInvestor.default_provider_id
            }`,
            ...item
        });

        if (Array.isArray(data)) {
            return data.map(item => setId(item));
        }

        return setId(data);
    }

    async getInvestorRelationships(offset = null, limit = null, sort_by = null, filters = {}, config = {}) {
        let extract = OrganisationApi.extractFilter(filters, 'provider_id');

        if (!extract.value) {
            throw new Error(`provider_id is required when requesting investor relationships for a provider.`);
        }

        let url = `${this.base_url}/${extract.value}/investor-relationships`;

        const response = await this.index(offset, limit, sort_by, extract.filters, {
            ...config,
            base_url: url
        });

        if (Array.isArray(response.data)) {
            response.data = this._filterProviderRelationshipResponseData(response.data);
        }

        return response;
    }
}

export default ProviderApi;
